const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuenbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#ffabea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.69,6.07c.73,1.28.12,2.31-1.35,2.31h0c-1.48,0-3.28-1.04-4.01-2.31-.73-1.28-.13-2.31,1.35-2.31s3.28,1.04,4.01,2.31ZM7.23,6.7c.74,1.27.74,3.35,0,4.63-.74,1.28-1.94,1.29-2.68.02-.74-1.27-.74-3.35,0-4.63.74-1.28,1.94-1.29,2.68-.02ZM12.34,9.62c-1.48,0-3.27,1.04-4.01,2.31-.73,1.28-.12,2.31,1.35,2.31s3.27-1.04,4.01-2.31c.73-1.28.12-2.31-1.35-2.31h0Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuenbit);
export default __webpack_public_path__ + "static/media/buenbit.f57d8366ca0c856fa3b22d1dabeba23c.svg";
export { ForwardRef as ReactComponent };